<div class="mdk-alert-modal">
    <mdk-alert-inline *ngIf="alert$ | async as alert" [alert]="alert" (closeAlert)="onCloseAlert()"></mdk-alert-inline>
</div>